import { maskCnpj } from '~/prix/utils/cnpj'

export const extraPropertiesFormatterMap: {
  [key: string]: {
    label: string
    format: (value: string | number | undefined) => string | number | undefined
    singular?: string
    plural?: string
    isCountable: boolean
    order?: number
  }
} = {
  position: {
    label: 'Ordem de atendimento',
    format: (value: string | number | undefined) => Number(value) + 1,
    isCountable: false,
    order: 0,
  },
  corporateName: {
    label: 'Razão Social',
    format: (value: string | number | undefined) => value,
    isCountable: false,
    order: 1,
  },
  tradeName: {
    label: 'Nome fantasia',
    format: (value: string | number | undefined) => value || 'Não Informado',
    isCountable: false,
    order: 2,
  },
  cnpj: {
    label: 'CNPJ',
    format: (value: string | number | undefined) =>
      value !== undefined && value !== null ? maskCnpj(String(value)) : value,
    isCountable: false,
    order: 3,
  },
  size: {
    label: 'Porte',
    format: (value: string | number | undefined) => value,
    singular: 'Porte',
    plural: 'Portes',
    isCountable: true,
    order: 4,
  },
  segmentDescription: {
    label: 'Segmento',
    format: (value: string | number | undefined) => value || 'Não Informado',
    singular: 'Segmento',
    plural: 'Segmentos',
    isCountable: true,
    order: 5,
  },
  mainCnaeDescription: {
    label: 'Cnae principal',
    format: (value: string | number | undefined) => value,
    singular: 'CNAE',
    plural: 'CNAEs',
    isCountable: true,
    order: 6,
  },
  description: {
    label: 'Descrição',
    format: (value: string | number | undefined) => value,
    isCountable: false,
    order: 7,
  },
  intersectionLengthKilometers: {
    label: 'Tamanho da intersecção (Km)',
    format: (value: string | number | undefined) => Number(value).toFixed(2),
    isCountable: false,
    order: 8,
  },
  duration: {
    label: 'Duração (minutos)',
    format: (value: string | number | undefined) => value,
    isCountable: false,
    order: 9,
  },
}

export const notExtraProperties = [
  'name',
  'value',
  'geoType',
  'geoId',
  'numerator',
  'denominator',
  'fillColor',
  'fillOpacity',
  'strokeColor',
  'strokeWeight',
  'strokeOpacity',
  'markerColor',
  'markerSize',
  'radius',
  'markerSymbol',
  'kind',
  'id',
]
